import React from "react";
import { SalesPage } from "./components/SalesPage";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full" data-id="element-0" data-mp="35c23whp4t7xc">
      <SalesPage data-id="element-1" data-mp="3k9b29vcurbyk" />
      <PurchasePopup data-id="element-2" data-mp="3k9uldfe8o6e6" />
    </div>;
}